import _ from 'lodash'
import { Ref } from 'vue'

import { formatQuery } from '@/misc/string_utils'
import router from '@/router'
import { useStore } from '@/store'

// une UM hors dialyse resterait active sans être visible ni désélectionnable dans le sélecteur
export default function useDialysisMedicalUnitsSelection(isDialysisMode: Ref<boolean>) {
  const store = useStore()

  function restrictSelectedMedicalUnitsToDialysis(): boolean {
    const selectedMedicalUnits: number[] | null = store.state.settings.selectedMedicalUnits
    if (!isDialysisMode.value || !selectedMedicalUnits) {
      return false
    }
    const dialysisMedicalUnitIds: number[] = store.getters.dialysisMedicalUnitIds
    const keptMedicalUnits = selectedMedicalUnits.filter((id) => dialysisMedicalUnitIds.includes(id))
    if (keptMedicalUnits.length === selectedMedicalUnits.length) {
      return false
    }
    store.commit('setSelectedMedicalUnits', keptMedicalUnits)
    // `um` (ancien nom de `mu`) est lu en priorité au chargement : le garder restaurerait la sélection
    router.replace({
      path: store.state.route.path,
      query: formatQuery({
        ..._.omit(store.state.route.query, 'um'),
        mu: keptMedicalUnits,
      })
    })
    return true
  }

  return { restrictSelectedMedicalUnitsToDialysis }
}
